// src/auth/ProtectedRoute.tsx
import * as React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthHydrated } from "../../hooks/useAuthHydrated";
import { useAuthStore } from "../../store/useAuthStore";

type Props = {
  fallback?: React.ReactNode; // optional UI while store hydrates
};

export default function ProtectedRoute({
  fallback = null,
}: Props): React.JSX.Element {
  const hydrated = useAuthHydrated();
  const location = useLocation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  // Wait until Zustand-persist finishes loading from localStorage
  if (!hydrated) {
    return <>{fallback}</>;
  }

  // If not authenticated → redirect to home "/"
  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // Otherwise, render the child route
  return <Outlet />;
}
